import { ComputeParentToggleSelectionParams } from './infinityList.types';

export const computeParentToggleSelection = ({
  currentSelected,
  childIds,
}: ComputeParentToggleSelectionParams): string[] => {
  const isAllChildrenSelected = childIds.every((id) => currentSelected.includes(id));
  return isAllChildrenSelected
    ? currentSelected.filter((id) => !childIds.includes(id))
    : [...new Set([...currentSelected, ...childIds])];
};
